"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hint = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const hintClass = (0, nano_theme_1.drule)({
    d: 'inline-flex',
    ai: 'center',
    gap: '6px',
    bdrad: '4px',
    pd: '1px 4px',
    fz: '11.6px',
    lh: '1.4em',
    bxz: 'border-box',
    ws: 'nowrap',
    us: 'none',
});
const Hint = (props) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("span", { ...props, className: hintClass({
            bd: '1px solid ' + styles.g(0.88, 0.28),
            bg: styles.g(0.99),
            col: styles.g(0.35, 0.7),
        }) + (props.className || '') }));
};
exports.Hint = Hint;
